import MultiselectSearchBar from "./components/MultiselectSearchBar";

function App() {
  return (
    <div>
      <MultiselectSearchBar />
    </div>
  );
}

export default App;
